/**
 * Page raccourci vers la gestion des actualités du portail.
 * Accessible aux rôles admin, super_admin, agent, marketing, bureau_stages.
 * Réutilise le composant Actualites du portail admin.
 */
import React from 'react';
import { Actualites } from '../PortailAdmin/Actualites';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

export default function ActualitesPage() {
  const user = useSelector((s: RootState) => s.auth.user);
  const role = user?.role || '';
  const titre = role === 'marketing'
    ? 'Publications Marketing'
    : role === 'bureau_stages'
      ? 'Publications Bureau des Stages'
      : 'Actualités du Portail';

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{titre}</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Publiez et gérez les actualités visibles par les étudiants et les parents.
          Choisissez l'audience (étudiants / parents / les deux) et le ciblage géographique (pôle, niveau, classe, option).
        </p>
      </div>
      <Actualites />
    </div>
  );
}
